import { gql } from '@apollo/client/core';
import { textBlockFragment } from './text-block.fragment';
import { imageBlockFragment } from './image-block.fragment';
import { buttonBlockFragment } from './button-block.fragment';
import { richTextBlockFragment } from './rich-text-block.fragment';
import { videoEmbedBlockFragment } from './video-embed-block.fragment';
export const containerBlockFragment = gql`
  fragment ContainerBlockFields on ContainerBlock {
    entryTitle
    alignment
    columns
    offset
    marginTop
    marginBottom
    padding
    background
    textColor
    blocksCollection(limit: 10) {
      items {
        __typename
        ...TextBlockFields
        ...ImageBlockFields
        ...ButtonBlockFields
        ...RichTextBlockFields
        ...VideoEmbedBlockFields
      }
    }
  }
  ${textBlockFragment}
  ${imageBlockFragment}
  ${buttonBlockFragment}
  ${richTextBlockFragment}
  ${videoEmbedBlockFragment}
`;
